export default function (): void {
	document.addEventListener('DOMContentLoaded', (ev) => {
		const openButtons = document.querySelectorAll<HTMLButtonElement>('.js-open-modal')
		const closeButtons = document.querySelectorAll<HTMLButtonElement>('.js-close-modal')
		const modals = document.querySelectorAll<HTMLElement>('.js-modal')


		openButtons.forEach((btn) => {
			btn.addEventListener('click', () => {
				const targetSelector = btn.dataset.target
				if (!targetSelector) return

				const target = document.querySelector<HTMLElement>(targetSelector)
				if (target) {
					target.classList.remove('hidden')
					target.classList.add('flex')
				}
			})
		})

		closeButtons.forEach((btn) => {
			btn.addEventListener('click', () => {
				const modal = btn.closest<HTMLElement>('.js-modal')
				if (modal) {
					modal.classList.remove('flex')
					modal.classList.add('hidden')
				}
			})
		})

		modals.forEach((modal) => {
			modal.addEventListener('click', (e: MouseEvent) => {
				if (e.target === modal) {
					modal.classList.remove('flex')
					modal.classList.add('hidden')
				}
			})
		})

		document.addEventListener('keydown', (e: KeyboardEvent) => {
			if (e.key === 'Escape') {
				modals.forEach((modal) => {
					modal.classList.remove('flex')
					modal.classList.add('hidden')
				})
			}
		})
	})
}
